import React from "react"
import Parser from 'html-react-parser';

import LayoutOne from "../../components/itemLayout1";
import LayoutTwo from "../../components/itemLayout2";
import CheckOutComponent from "../../components/checkOutComponent";
import SearchProductLayout from "../../components/searchedProductLayout";

import OwlCarousel from 'react-owl-carousel';

import Request from "../../Request"
import {poundIcon} from "../../settings"


import _ from "lodash"
import Async from "async"
import "../../less/stylesheet/carousel-owl.css"
import "../../less/stylesheet/price-estimate.css"
import "../../less/stylesheet/btns.css"
import "../../less/stylesheet/form-input.css"
import {Helmet} from "react-helmet";
import {debounce} from "throttle-debounce";

const $ = window.$;
const isLoggedIn = localStorage.getItem('token') ? true : false;
const options = {
    autoplay: false,
    loop: false,
    nav: true,
    autoWidth: true,
    dots: false,
    margin: 15,
    navSpeed: 1000,

}

class PriceEstimator extends React.Component {

    constructor() {
        super()
        this.state = {
            products: [],
            categoryList: [],
            selectIndex: 0,
            totalPrice: 0,
            openType: 'direct',
            defaultMin: 25,
            searchedProducts: []

        }
        this.debouncedSearch = debounce(200, false, this.searchProductQuery);

    }

    async _getUserSubscription() {
        if (isLoggedIn) {
            let {success, data} = await Request.getUserSubscription();
            if (success && data && data.subscriptionPlan && data.subscriptionPlan._id) {
                this.setState({defaultMin: 15})
            }
        }
    }

    async searchProductQuery(search) {
        if (search.length >= 3) {
            let {success, data} = await Request.searchProduct({search})
            if (success) {
                this.setState({searchedProducts: data})
            }
        } else {
            this.setState({searchedProducts: []})
        }
    }


    _searchProduct = (e) => {
        this.setState({search: e.target.value});
        this.debouncedSearch(e.target.value);
    }


    selectTab(selectIndex) {
        this.setState({selectIndex, search: '', searchedProducts: []})
    }

    componentDidMount() {
        this._getCategory();
        $("body").addClass("priceEstiamterPage");
    }

    componentWillUnmount() {
        $("body").removeClass("priceEstiamterPage");
    }

    async _getCategory() {
        let resp = await Request.getCategory();
        if (resp && resp.length) {
            this.setState({categoryList: resp})
        }
        this._getUserSubscription()
    }

    _chooseProduct = (item) => {
        let cloneProducts = _.clone(this.state.products);
        let findProduct = _.find(cloneProducts, (eachPro) => {
            return eachPro._id == item._id;
        })

        if (!findProduct) {
            item.quantity = 1;
            cloneProducts.push(item);
        } else {
            findProduct.quantity += 1;
        }
        this.setState({products: cloneProducts}, () => {
            this.calculatePrice()
        })
    }

    resetCart() {
        this.setState({products: [], totalPrice: 0})
    }

    calculatePrice() {
        let {products} = this.state;
        let totalPrice = 0;
        Async.each(products, (item, cb) => {
            totalPrice += (item.price ? item.price : 0) * (item.quantity ? item.quantity : 0);
            cb()
        }, () => {
            this.setState({totalPrice})
        })
    }

    _updateQuantity = (item, type) => {
        let cloneProducts = _.clone(this.state.products);
        let findProduct = _.find(cloneProducts, (eachPro) => {
            return eachPro._id == item._id;
        })
        if (findProduct) {
            if (type == 'minus') {
                findProduct.quantity = findProduct.quantity > 1 ? findProduct.quantity - 1 : 0;
                if (findProduct.quantity == 0) {
                    cloneProducts = _.reject(cloneProducts, (it11) => {
                        return it11._id == findProduct._id;
                    })
                }
            } else {
                findProduct.quantity += 1
            }
            this.setState({products: cloneProducts}, () => {
                this.calculatePrice();
            })
        }
    }

    placeOrderRender = () => {
        let {closeModal} = this.props;
        if (closeModal) {
            if (window.innerWidth < 768) {
                window.hideMenuFxn()
            }
            this.props.closeModal()
        } else {
            if (isLoggedIn) {
                window.location.href = "/profile"
            } else {
                let groupPro = _.groupBy(this.state.products, (item) => {
                    return item.categoryId;
                })
                let createParams = ''
                _.each(groupPro, (item, key) => {
                    if (!createParams) {
                        createParams = key;
                    } else {
                        createParams = createParams + '-' + key
                    }
                })
                // window.location.href = `/home?ids=${createParams}`
                window.location.href = `/place-order`
            }

        }
    }

    render() {
        let {selectIndex, categoryList, products, totalPrice, defaultMin, searchedProducts, search} = this.state;
        let {btnText = 'Place order', closeModal} = this.props;
        const categoryListComponent = () => {
            return (
                <React.Fragment>
                    {categoryList && categoryList.length ? categoryList.map((item, index) => {
                        return (
                            <li className="board-item" key={index}>
                                {/*href={`#${item.slugName}`}*/}
                                <a className={`show ${index == selectIndex ? 'active' : null}`}
                                   data-toggle="tab"
                                   title={item.name} onClick={() => this.selectTab(index)}>
                                              <span className={`round-tabs ${index}`}>
                                                      <img src={item.image.url}/>
                                              </span>
                                    <span className="tab-head">{item.name}</span>
                                </a>
                            </li>
                        )
                    }) : ''}
                </React.Fragment>
            )
        }
        return (
            <React.Fragment>
                <Helmet title={'Prices For Dry Cleaning, Laundry & Other Services - 1 Stop Wash'}
                        meta={[
                            {
                                name: 'description',
                                content: 'Find out how much your laundry and dry cleaning order will cost with our price estimator tool. Let 1 Stop Wash help you achieve Less Laundry & More Life.',
                            },
                            {
                                name: 'keywords',
                                content: 'Laundry & Dry Cleaning Prices',
                            },
                        ]}
                        link={[
                            {
                                href: "https://1stopwash.com/price-estimator",
                                rel: "canonical"
                            }
                        ]}
                >
                </Helmet>

                {categoryList && categoryList.length ?
                    <section id="tab-price" key={selectIndex}>
                        <div className="container">
                            <div className="row">
                                <div className={`col-md-12 ${closeModal ? 'mt-3' : 'mt-5'}`}>
                                    <p className="nte"><i className="fa fa-info-circle"></i>
                                        *No need to itemize your order when placing an order, simply select the services
                                        you'd
                                        like at the order details page. Estimate the price of your order here
                                    </p>
                                </div>
                                <div className={`col-md-12`} style={{paddingTop: '2%', paddingBottom: '1%'}}>
                                    <div className={'row search-block'}>
                                        <div className={'col-md-8'}>
                                            <div className={'title'}>
                                                WHAT SERVICE DO YOU REQUIRE?
                                            </div>
                                        </div>
                                        <div className={'col-md-4'}>
                                            <div className="prices-search">
                                                <i className={'fa fa-search'}></i>
                                                <input className="prices-search-input" placeholder="Search"
                                                       value={this.state.search}
                                                       onChange={(e) => debounce(200, this._searchProduct(e))}/>
                                                {this.state.search ?
                                                    <i className={'fa fa-times crossBtn'} onClick={() => {
                                                        this.setState({search: '', searchedProducts: ''})
                                                    }}></i> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 sticky-service">
                                    <div className="board" style={{marginTop: 14}}>
                                        <ul className="nav nav-tabs  owlHeight service_owl" id="myTab">
                                            <OwlCarousel className="owl-theme" style={{overflow: "hidden"}}
                                                         startPosition={selectIndex}
                                                         {...options}>
                                                {categoryListComponent()}
                                            </OwlCarousel>
                                        </ul>
                                    </div>

                                    {/* <div className={'display_mob_tab price-estimate'}>
                                        <ul>
                                            {categoryListComponent()}
                                        </ul>
                                    </div>*/}
                                </div>
                                <div className="col-md-12 col-lg-8">
                                    {search && searchedProducts && searchedProducts.length ?
                                        <div className="mt-4">
                                            <SearchProductLayout products={searchedProducts}
                                                                 currency={poundIcon}
                                                                 chooseProduct={this._chooseProduct}/>
                                        </div> :
                                        <div className="tab-content" key={selectIndex}>

                                            {categoryList.map((item, index) => {
                                                return (
                                                    <div key={index}
                                                         className={`tab-pane fade ${selectIndex == index ? 'in active show' : ''}`}
                                                         id={`${item.slugName}`}>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="tabs-header-colum">
                                                                    <h2 className="tb-lser mb-2">{item.name}</h2>
                                                                    <span>{Parser(item.description)}</span>
                                                                </div>
                                                            </div>


                                                            {item.subCategory && item.subCategory.length ? item.subCategory.map((subItem, key) => {
                                                                return (
                                                                    <div className="col-md-6" key={key}>
                                                                        {subItem.layout == 'layoutOne' ?
                                                                            <LayoutOne subCategory={subItem}
                                                                                       currency={poundIcon}
                                                                                       chooseProduct={this._chooseProduct}/> :
                                                                            <LayoutTwo subCategory={subItem}
                                                                                       currency={poundIcon}
                                                                                       chooseProduct={this._chooseProduct}/>}

                                                                    </div>
                                                                )
                                                            }) : null}

                                                        </div>
                                                        <div className="row sfetxt">
                                                            <div className="col-md-12">
                                                                {item.descriptionBottom ? Parser(item.descriptionBottom) : ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}

                                            <div className="clearfix"></div>
                                        </div>}

                                    <div className="row" id="hides">
                                        <div className="col-md-12">
                                            <div className="total-estimate-mb" id="myDIV" onClick={() => {
                                                window.showMenuFxn()
                                            }}>
                                                <div className="total-estimate-left">
                                                    <h5 className="tolal-price-all">{poundIcon}{totalPrice ? totalPrice.toFixed(2) : 0}</h5>
                                                </div>
                                                <div className="total-estimate-right"
                                                     style={{paddingTop: 18, paddingBottom: 18}}>
                                                    <button className="detail-estimat" id="show-hidden-menu">
                                                        <h4>Estimate</h4>
                                                        {/*<span>Order stationary</span>*/}
                                                        <img src="/assets/img/arrow-white.svg"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-4 price-page">
                                    <CheckOutComponent products={products}
                                                       key={products}
                                                       btnText={btnText}
                                                       totalPrice={totalPrice}
                                                       defaultMin={defaultMin}
                                                       closeModal={this.props.closeModal}
                                                       _updateQuantity={this._updateQuantity}
                                                       placeOrderRender={this.placeOrderRender}
                                                       currency={poundIcon}
                                                       resetCart={() => this.resetCart()}/>
                                    <div className="box-bottom-cont">
                                        {/*<p>*Please note that the final price may vary and
                                            it will
                                            be calculated after the cleaning process.</p>*/}
                                    </div>
                                    <div className="lef-side-botn mb-5">
                                        <h3>ABOUT OUR SERVICES</h3>
                                        <p><img src="/assets/img/right.svg"/> Free collection and delivery.</p>
                                        <p><img src="/assets/img/right.svg"/> {poundIcon}{defaultMin} minimum order.</p>
                                        <p><img src="/assets/img/right.svg"/> No service fees</p>
                                        {/*<p><img src="/assets/img/right.svg"/> {poundIcon}5 no show fee</p>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> : <section id="tab-price" className="tab-price">
                        <div className="container">
                            <div className={'loadingPriceEstimate'}>
                                <h1>Loading...</h1>
                            </div>
                        </div>
                    </section>}


            </React.Fragment>
        )
    }
}


export default PriceEstimator;
